import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from '_atoms';
import { CreatePromotionRequestButton } from '_molecules';
import { NewJobs, PromotionRequestsTable, SelfSubmittedCandidatesDashboard } from '_organisms';
import { getPromotionRequestsOnDashboardRecruiterLead } from 'actions';
import { useQuery } from 'helpers/useLocation';
import { MyActiveCandidates } from '../DashboardHRLead/DashboardHRLead';
import { TABS } from './constants';
import './style.scss';

export const DashboardRecruiterLead: React.FC = () => {
  const { t } = useTranslation();
  const query = useQuery();

  const [tab, setTab] = useState((query.tab as string) || TABS[0].key);
  const tabs = TABS.map(item => ({ ...item, label: t(item.label) }));

  return (
    <div className="dashboard-recruiter-lead">
      <NewJobs />
      <Tabs className="dashboard-recruiter-lead__tabs" activeTab={tab} onChange={setTab} items={tabs} />
      {
        {
          [TABS[0].key]: <MyActiveCandidates leadDashboard recruiterDashboard setTabsLoading={() => {}} />,
          [TABS[1].key]: <SelfSubmittedCandidatesDashboard dashboard="recruiter-lead" />,
          [TABS[2].key]: (
            <PromotionRequestsTable
              fetchRequests={getPromotionRequestsOnDashboardRecruiterLead}
              cardTitle={t('translation:dashboard_recruiter_lead.tab_promotion_requests')}
              extra={<CreatePromotionRequestButton />}
            />
          ),
        }[tab]
      }
    </div>
  );
};
